import React, { useState, useEffect } from 'react';
import Breadcrumb from '../common/Breadcrumb';
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { displayMessage } from '../../Utils/helper';
import { getWorkkflowCombinations } from '../../services/ApiManageWorkflow';
import { getOrderDetails } from '../../services/ApiIndentation';
//import RepoData from '../../Utils/DataSamples/SampleOrderResults.json';
import TableComponent from './TableComponent';
import GraphComponent from './GraphComponent';
//import '../../assets/css/table.css';

function IndentationPage() {
    const { state } = useLocation();
    const [combinations, setCombinations] = useState([]);
    const [selectedSKU, setSelectedSKU] = useState(0);
    const [safetystock, setSafetystock] = useState(null);
    const [eoq, setEOQ] = useState(null);
    const [ReportData, setReportData] = useState(null);
    useEffect(() => {
        const init = async () => {
            const data = await getWorkkflowCombinations(state?.workflow?.workflow_id);
            //       console.log(data)
            if (data !== null) {
                setCombinations(data)
            } else {
                setCombinations([])
            }
        }
        init();
    }, [])

    if (!combinations) {
        return false;
    }

    //console.log(state?.workflow)

    // {
    //     "sku_id": 1,
    //     "sku_name": "0064-601ASSY",
    //     "level1": "India",
    //     "level2": "North",
    //     "level3": "North-1",
    //     "level4": "",
    //     "level5": ""
    //   }
    function getFormattedPath(obj) {
        let levels = ["level1", "level2", "level3", "level4", "level5"];
        let path = [];

        for (let key of levels) {
            if (!obj[key]) break;  // Stop if value is empty or null
            path.push(obj[key]);
        }

        return path.join("/");
    }

    const options = combinations.map(ob => ({
        label: `${ob.sku_name} - ${getFormattedPath(ob)}`,
        value: {
            sku_name: ob.sku_name,
            location: getFormattedPath(ob),
            sku_id: ob.sku_id
        }
    }))

    const formatOptionLabel = (data, { context }) => {
        return context === "menu" ? <div>
            <span>{data.label}</span>
        </div>
            : <>{data.label}</>
    };

    const combinationSelectChangeHandler = async (selected) => {
        try{
            const result = await getOrderDetails(selected?.value?.sku_name, state?.workflow?.workflow_id);
      
            if (result !== undefined) {            
               setSafetystock(result[selected?.value?.sku_name][0]['Safety_Stock']);
               setEOQ(result[selected?.value?.sku_name][0]['EOQ']);
               setReportData(result.Values);
            }
        }catch(err){
            console.error(err);
            setEOQ(null)
            setSafetystock(null)
            setReportData(null)
            displayMessage("danger","Error","Error occured while fetching details");
        }
        
    }

    return (
        <div>
            <Breadcrumb List={[{ path: "/Dashboard", name: "Dasboard" }, { path: "/indentation", name: "Indentation" }, { path: "#", name: state?.workflow?.workflow_name }]} />
            <div>
                <div className="mycontainer manage-workflow-box">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="indentation">
                                <h4>Indentation : {state?.workflow?.workflow_name} </h4>
                                <p>User can find the details of Indentation here</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12">
                            <div className="indentation">
                                <label>Combination</label>
                                <Select
                                    closeMenuOnSelect={true}
                                    onChange={combinationSelectChangeHandler}
                                    formatOptionLabel={formatOptionLabel}
                                    isSearchable
                                    options={options}
                                />
                            </div>
                        </div>
                    </div>
                 { Boolean(eoq) &&  <>
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12">
                            <div className='container indent1'>
                                <table className="table  indenttable table-bordered table-hover" style={{ width: "100%" }}>
                                    <tbody>
                                        <tr>
                                            <td>Safety_Stock</td>
                                            <td>{safetystock}</td>
                                        </tr>
                                        <tr>
                                            <td>EOQ</td>
                                            <td>{eoq}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            {ReportData && <>
                                <div className="table-container">
                                    <h1>Tabular Report</h1>
                                    <TableComponent data={ReportData} />

                                </div>
                                <div className="graph-container">
                                    <h1>Graphical Report</h1>
                                    <GraphComponent data={ReportData} />
                                </div>
                            </>
                            }
                        </div>
                    </div>
                    </>}
                </div>

            </div>
        </div>
    )
}

export default IndentationPage


// {
//     "combination_id": 37,
//     "workflow_id": "0ce8c92c-2089-4671-84eb-772324b6d284",
//     "user_id": "a8a4e241-883d-4841-ab1d-437106654754",
//     "combination": "[{\"sku_id\": 333, \"sku_name\": \"850056\", \"level1_id\": 1, \"level2_id\": 2, \"level3_id\": 15, \"level4_id\": 26, \"level5_id\": 272}, {\"level1\": \"India\", \"level2\": \"North\", \"level3\": \"North-1\", \"level4\": \"UP\", \"level5\": \"Kanpur\"}]",
//     "sql_query_string": "\n    query from valid_combinations_details here\n    ",
//     "status": "PROCESSING",
//     "granularity": "Transaction",
//     "workflow_name": "Jocky",
//     "creation_time": "2025-02-03T08:15:31.213434",
//     "begin_date": "2025-02-03",
//     "workflow_description": "Jocky Client",
//     "completion_time": null,
//     "process_date": "2025-02-03T08:15:31.213434",
//     "approval_status": "PENDING"
// }